import React, { useEffect, useState } from 'react';
import { Calendar } from 'react-date-range';
import classes from './DatePicker.module.css';
import ModalComponent from '../../ModalComponent/ModalComponent';
import moment from 'moment';
import { UilSchedule } from '@iconscout/react-unicons';
import { momentTimeFormater } from '../../../utils/timeHelper';

const DatePicker = ({ date, setDate, disabled, showArrow = false, format = null, disableFutureDate = true, maxSelectableDays = 0, ...props }) => {
    const maxFutureDate = momentTimeFormater().add(maxSelectableDays, 'day').startOf('day').toDate();
    const [showCalender, setShowCalender] = useState(false);
    const [currentDate, setCurrentDate] = useState(null);

    useEffect(() => {
        if (date) {
            const selectedMomentDate = moment(date);
            setCurrentDate(selectedMomentDate);
            handleSelect(selectedMomentDate.toDate());
        }
    }, [JSON.stringify(date)]);

    const handleSelect = (date) => {
        const currentTime = moment();
        const updatedDate = moment(date).hour(currentTime.hour()).minute(currentTime.minute()).second(currentTime.second());

        const finalDate = updatedDate.toDate();
        setDate(finalDate);
        setCurrentDate(updatedDate);
        setShowCalender(false);
    };
    const handleBackClick = () => {
        const previousDay = moment(currentDate).subtract(1, 'day');
        setDate(previousDay.toDate());
        setCurrentDate(previousDay);
    };

    const handleNextClick = () => {
        const nextDay = moment(currentDate).add(1, 'day');
        if (disableFutureDate && nextDay.startOf('day').isAfter(maxFutureDate)) return;
        setDate(nextDay.toDate());
        setCurrentDate(nextDay);
    };

    const style = {
        opacity: disabled && '0.5',
        height: showArrow && '2Vh',
    };

    const isNextDisabled = disableFutureDate && currentDate && moment(currentDate).add(1, 'day').startOf('day').isAfter(maxFutureDate);

    return (
        <div>
            <div className={classes.DatePickerContainer} style={disabled ? { opacity: '0.5' } : {}}>
                {showArrow && (
                    <div className={classes.ArrowButton} onClick={() => !disabled && handleBackClick()}>
                        {'<'}
                    </div>
                )}
                <div className={classes.DateContainer} onClick={() => !disabled && setShowCalender(!showCalender)} style={showArrow ? { height: '2vw' } : {}}>
                    <div className={classes.Date}>{currentDate && format ? moment(currentDate).format(format) : currentDate ? moment(currentDate).format('MMM DD YYYY') : ''}</div>
                    <div className={classes.CalendarIcon}>
                        <UilSchedule style={{ color: 'var(--color-primary)' }} size={'1.3vw'} />
                    </div>
                </div>
                {showArrow && (
                    <div className={`${classes.ArrowButton} ${isNextDisabled ? classes.DisabledArrow : ''}`} onClick={() => !disabled && handleNextClick()}>
                        {'>'}
                    </div>
                )}
            </div>

            {showCalender && (
                <ModalComponent isOpen={showCalender} setOpen={setShowCalender}>
                    <Calendar
                        className={classes.CalendarPopUp}
                        date={moment(date).toDate()}
                        maxDate={disableFutureDate ? maxFutureDate : undefined}
                        onChange={handleSelect}
                        autoFocus={false}
                        color="var(--color-primary)"
                        fixedHeight={true}
                    />
                </ModalComponent>
            )}
        </div>
    );
};

export default DatePicker;
